"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const documentUtil_1 = __importDefault(require("helpers/documentUtil"));
const sidebarBody_1 = __importDefault(require("./sidebarBody"));
const sidebarHeader_1 = __importDefault(require("./sidebarHeader"));
require("@hotmart/cosmos/dist/sidebar");
const SIDEBAR_PORTAL_ID = 'app-club-admin-sidebar-container';
const sidebarRootElement = documentUtil_1.default.createElement(SIDEBAR_PORTAL_ID);
const Sidebar = ({ children, isOpen, onClose, className }) => {
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        isOpen ? (_a = ref.current) === null || _a === void 0 ? void 0 : _a.openSidebar() : (_b = ref.current) === null || _b === void 0 ? void 0 : _b.closeSidebar();
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        const current = ref.current;
        onClose && (current === null || current === void 0 ? void 0 : current.addEventListener('close', onClose));
        return () => onClose && (current === null || current === void 0 ? void 0 : current.removeEventListener('close', onClose));
    }, [onClose]);
    return (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)("hot-sidebar", { "data-test": "hot-sidebar-component", ref: ref, class: className, ...(isOpen && { open: true }), id: "sidebar", children: children }), sidebarRootElement);
};
Sidebar.Header = sidebarHeader_1.default;
Sidebar.Body = sidebarBody_1.default;
exports.default = Sidebar;
